import { Injectable } from "@angular/core";
import { SocialSharing } from "@ionic-native/social-sharing";
import { HttpProvider } from "../../providers/http/http";
import { APP_CONFIG } from "../../environment";
import { LoggerProvider } from "../logger/logger";
import { Platform } from "ionic-angular";

@Injectable()
export class SocialProvider {

  constructor(private socialSharing: SocialSharing, private httpProvider: HttpProvider, private platform: Platform) {}

  getReferralCode(): Promise<any> {
    return this.httpProvider.put(APP_CONFIG.API_URL + 'api/Customers/' + this.httpProvider.getAuthCustomerId() + '/Moneytransfer/Promotions/ShareCode', {}); 
  }

  getReferralCodeNew(): Promise<any> {
    let customerId = this.httpProvider.getAuthCustomerId();
    if(!customerId){
      customerId = this.httpProvider.getAuthLiteReservedCustomerId();
    }
    return this.httpProvider.put(APP_CONFIG.API_URL + 'api/v1/Customers/' + customerId + '/Moneytransfer/Promotions/ShareCode', {}); 
  }

  share(message, imageData = "") {
    return new Promise((resolve, reject) => {
      if (!this.platform.is('cordova'))
        LoggerProvider.info(this, 'Share message', message);

      this.socialSharing.share(message, null, imageData, null).then(
        () => resolve(true),
        err => {
          if (!this.platform.is('cordova')) {
            resolve(false);
            LoggerProvider.info(this, 'Sharing not available');
          }
          else
            reject()
        }
        );
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/social/social.ts